import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DashboardService } from '../../../pages/dashboard/dashboard.service';
import { StorageService } from '../../../services/storage/storage.service';
import { LayoutService } from '../../../services/layout.service';
/** Displays Staff pages in an iframe based on the menuitem */
@Component({
  selector: 'ag-staff-content',
  templateUrl: './staff-content.component.html',
  styleUrls: ['./staff-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StaffContentComponent implements OnChanges {
  @Input() staffMenu: any;
  @Input() locations: any = [];
  @Input() isFullRecord: any;
  @Input() homeLocationLink: string;
  @Input() locationsURL: any;
  pageLoaded = false;

  printStatus: boolean;
  url: string;

  constructor(
    private _dashboardService: DashboardService,
    public layoutService: LayoutService,
    private _storageService: StorageService,
    private _titleService: Title,
  ) {
    document.scrollingElement.scrollTop = 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.staffMenu?.currentValue) {
      let fullLabel = this.staffMenu.fullLabel;
      if (!fullLabel) {
        fullLabel = this._dashboardService.fullLabel(this.staffMenu.menuItem);
      }

      const title =
        fullLabel +
        ' | ' +
        this._storageService.getCid().toUpperCase() +
        ' | ' +
        this._storageService.getLid() +
        ' | AutoGraphics Inc.';

      this._titleService.setTitle(title);

      const url = new URL(this.staffMenu.url);
      url.searchParams.set('t', Date.now().toString());
      this.url = url.toString();
    }
  }
}
